import { AbstractPmsApiService } from "./abstract.service";
import { SingleTransaction } from "../models";

/**
 * @class SingleTransactionPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<SingleTransaction>}
 */
export class SingleTransactionPmsApiService extends AbstractPmsApiService {
    
    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {
        
        return '/property/:propertyId/single-transaction/:transactionId';
    }
    
    /**
     * @param {Object.<string, *>} attributes
     * @returns {SingleTransaction}
     * @protected
     */
    newModel(attributes, ...params) {
        
        return new SingleTransaction(attributes);
    }
    
    /**
     * @param {Object=} params
     * @param {Property=} property
     * @param {Transaction=} transaction
     * @returns {Promise.<SingleTransaction>}
     */
    get (params = {}, property = null, transaction = null) {
        if (!transaction) {
            return Promise.reject(new Error('Transaction is required'));
        }
    
        const url = this.url({propertyId: property ? property.id : 0, transactionId:transaction.id});
        
        return this.http
                   .get(url, {
                       headers: this.authHeaders,
                       params
                   })
                   .then(this.getDataExtractor())
                   .catch(this.getErrorHandler());
    }

    update (model, property = null, transaction = null) {
        if (!transaction) {
            return Promise.reject(new Error('Transaction is required'));
        }
    
        const url = this.url({propertyId: property ? property.id : 0, transactionId:transaction.id});
        
        return this.http
                   .put(url, model, {
                       headers: this.authHeaders
                   })
                   .then(this.getStatusExtractor())
                   .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/single-transaction.service.js